import { render, staticRenderFns } from "./StoreIcon.vue?vue&type=template&id=3896482d"
import script from "./StoreIcon.vue?vue&type=script&lang=js"
export * from "./StoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports